import { HostListener, Component } from '@angular/core';

import {
    NavController,
    NavParams,
    PopoverController,
    ViewController,
    AlertController,
    LoadingController,
    ToastController,
    ModalController
} from 'ionic-angular';

import { Horse } from '../../../../model/horse';

import { AlertMessager } from "../../../../lib/alertMessager";
import { HorseSearchPopover } from "../../../search/horse-search";
import { UserSearchPopover } from '../../../search/user-search';
import { Organization } from '../../../../model/organization';
import { NominationService } from '../../../../services/nomination.service';
import { NominationHorseSlot } from '../../../../model/nominationHorseSlot';

@Component({
    selector: 'page-new-stallion',
    templateUrl: 'new-stallion.html'
})
export class NewStallionPage {
    selectedHorseSlot: NominationHorseSlot = new NominationHorseSlot();

    horseOnes: Horse[];
    horseTwos: Horse[];

    editing: boolean;
    popoverActive: boolean = false;

    horseSlots: NominationHorseSlot[] = [];
    createdHorseSlots: NominationHorseSlot[] = [];

    organization: Organization;
    organizations: Organization[] = [];

    constructor(private nav: NavController, navParams: NavParams, private loadingController: LoadingController, private popoverController: PopoverController, private alertController: AlertController,
        private alert: AlertMessager, private nominationService: NominationService, private viewController: ViewController, private toast: ToastController, private modalController: ModalController) {
        this.organization = navParams.get("organization");
        this.organizations = navParams.get("organizations");
        
        let existingHorseSlot = navParams.get("horseSlot");

        Object.assign(this.selectedHorseSlot, existingHorseSlot);

        if (existingHorseSlot == null || existingHorseSlot == undefined) {
            this.setupNewHorseSlot();
        } else {
            this.editing = true;
        }

        this.horseSlots.push(this.selectedHorseSlot);
    }

    selectHorseSlot(index) {
        this.selectedHorseSlot = this.horseSlots[index];
    }

    addNewHorseSlot() {
        this.setupNewHorseSlot();
        this.horseSlots.push(this.selectedHorseSlot);
    }

    removeEntry(entry) {
        let index = this.horseSlots.indexOf(entry);
        this.horseSlots = this.horseSlots.filter(x => x != entry);
        this.selectedHorseSlot = this.horseSlots.length > index ? this.horseSlots[index] : this.horseSlots[index - 1];
    }

    openHorseSearchPopover(searchEvent, riderOne) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(HorseSearchPopover, {
            horses: riderOne ? this.horseOnes : this.horseTwos
        }, {
            cssClass: 'horse-search'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null && data.horse != undefined) {
                this.selectedHorseSlot.horseId = (data.horse as Horse).id;
            }
        })
    }

    openUserSearch(searchEvent, title, callback) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: title,
            organizations: this.organizations
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    setupNewHorseSlot() {
        this.selectedHorseSlot = new NominationHorseSlot();

        this.selectedHorseSlot.horseId = -1;
    }

    delete() {
        let alert = this.alertController.create({
            title: 'Horse Slot Removal',
            message: 'Are you sure you want to remove this horse slot?',
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {0
                        this.nominationService.deleteNominationHorseSlot(this.selectedHorseSlot)
                            .then(data => {
                                this.setupNewHorseSlot();
                            }), error => {
                                this.alert.showError("Horse Slot Removal Error", error);
                            };
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();
    }

    create(pay: boolean) {
        let entryInvalid = false;

        this.horseSlots.forEach((entry) => {
            if (entryInvalid)
                return;
        });

        if (entryInvalid)
            return;

        let loader = this.loadingController.create({
            content: (this.editing ? 'Editing' : 'Creating') + ' horse slot...',
        });

        loader.present();

        if (this.editing) {
            this.nominationService.updateNominationHorseSlot(this.selectedHorseSlot)
                .then(data => {
                    if ((data as any).message != null && (data as any).message != undefined) {
                        this.alert.showError("Horse Slot Update Failed", (data as any).message);
                        loader.dismiss();
                    } else {
                        this.toast.create({
                            message: 'Horse Slot was edited successfully.',
                            duration: 1500,
                            position: 'middle'
                        }).present();

                        this.viewController.dismiss({ entry: data });
                        loader.dismiss();
                    }
                }, error => {
                    this.alert.showError("Horse Slot Update Error", error);
                    loader.dismiss();
                });
        } else {
            let processNominationHorseSlotResponse = (data => {
                loader.dismiss();
                if ((data as any).message != null && (data as any).message != undefined) {
                    this.alert.showError("Horse Slot Create Failed", (data as any).message);
                } else {
                    if (this.organization.paymentRequiredOnEntry && pay) {
                        let callback = (removed) => { this.viewController.dismiss(); };

                        callback = (removed) => {
                            this.setupNewHorseSlot();

                            if (removed)
                                return;

                            let addedNominationHorseSlot = (data as NominationHorseSlot);

                            let alert = this.alertController.create({
                                title: 'Horse Slot Added!',
                                message: 'Would you like to create more horse slots for this nomination?',
                                buttons: [
                                    {
                                        text: 'Yes',
                                        handler: () => {
                                            this.createdHorseSlots.push(addedNominationHorseSlot);
                                        }
                                    },
                                    {
                                        text: 'No',
                                        role: 'cancel',
                                        handler: () => { }
                                    }]
                            });

                            alert.present();
                        };
                    } else {
                        this.setupNewHorseSlot();

                        let addedNominationHorseSlot = (data as NominationHorseSlot[])[0];

                        let alert = this.alertController.create({
                            title: 'Horse Slot Confirmed!',
                            message: 'Would you like to create more horse slots for this nomination?',
                            buttons: [
                                {
                                    text: 'Yes',
                                    handler: () => {
                                        this.createdHorseSlots.push(addedNominationHorseSlot);
                                    }
                                },
                                {
                                    text: 'No',
                                    role: 'cancel',
                                    handler: () => { }
                                }]
                        });

                        alert.present();
                    }
                }
            });

            this.nominationService.addNominationHorseSlot(this.selectedHorseSlot)
                .then((data => processNominationHorseSlotResponse(data))
                , error => {
                    this.alert.showError("Horse Slot Create Error", error);
                    loader.dismiss();
                });
        }
    }

    cancel() {
        this.viewController.dismiss({ horseSlots: this.createdHorseSlots });
    }

    back() {
        this.viewController.dismiss({ horseSlots: this.createdHorseSlots });
    }

    _bdClick() {
        return this.viewController.dismiss({ horseSlots: this.createdHorseSlots });
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast() && !this.popoverActive) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/stallions/new-stallion.ts